import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Api } from '../../services/api/api.service';
import { LinkLabelComponent } from '../core/labels/link-label.component';

@Component({
  selector: 'app-api-design',
  imports: [CommonModule, LinkLabelComponent],
  template: `
    <ul>
      <li><app-link-label (click)="login()">Login</app-link-label></li>
      <li>
        <app-link-label (click)="getWatchlist()">Get watchlist</app-link-label>
      </li>
      <li><app-link-label (click)="getUser()">Get user</app-link-label></li>
    </ul>
    <div>result: {{ result | json }}</div>
  `,
  styles: ``,
})
export class ApiDesignComponent {
  private api = inject(Api);

  result: any;

  async login() {
    this.result = await this.api.auth.login({
      password: 'password',
      userName: 'jkrebs1',
    });
  }

  async getWatchlist() {
    this.result = await this.api.watchlist.get();
  }

  async getUser() {
    this.result = await this.api.user.get();
  }
}
